import { defineAsyncComponent } from 'vue';

import LDRouteGuard from '@/components/core/LDRouteGuard';
import { constants } from '@/config';

const App = () => import('@/app/tiktok/App.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const Overview = () => import('@/app/tiktok/pages/Overview.vue');
const Ugc = defineAsyncComponent(() => import('@/app/tiktok/pages/Ugc.vue'));
const TrendingSounds = defineAsyncComponent(() => import('@/app/tiktok/pages/TrendingSounds.vue'));
const TrendingHashtags = defineAsyncComponent(
  () => import('@/app/tiktok/pages/TrendingHashtags.vue'),
);
const TikTokLikeShop = () => import('@/app/ecommerce/pages/LikeShop.vue');
const AnalyticsYourPostsPage = () =>
  import('@/components/core/analytics/AnalyticsYourPostsPage.vue');

const PAGE_LEVEL_TOP = `TikTok`;

export default {
  path: 'tiktok',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'tiktok',
      path: '',
      redirect: { name: 'tiktok.overview' },
    },
    {
      name: 'tiktok.overview',
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'tiktok.overview.report',
      path: 'overview/report',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      name: 'tiktok.yourPosts',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.TIKTOK,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'tiktok.yourPosts.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.TIKTOK,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      name: 'tiktok.ugc',
      path: 'ugc',
      component: Ugc,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - UGC`,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'tiktok.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.TIKTOK,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Boards`,
          },
        },
      ],
    },
    {
      name: 'tiktok.trendingSounds',
      path: 'trending-sounds',
      component: LDRouteGuard,
      props: {
        component: TrendingSounds,
        requiredFeatureFlag: 'tiktokTrendingSounds',
        to: { name: 'tiktok.overview' },
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Trending Sounds`,
      },
    },
    {
      name: 'tiktok.trendingHashtags',
      path: 'trending-hashtags',
      component: TrendingHashtags,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Trending Hashtags`,
      },
    },
    {
      name: 'tiktok.likeshop',
      path: 'likeshop',
      component: TikTokLikeShop,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - LikeShop`,
      },
    },
  ],
};
